<template>
  <li 
    :id="slug"
    class="journal"
    :class="{ 
      faded: faded,
      selected: selected,
      fadein: fadein,
    }"
  >
    <a 
      class="name"
      :class="{ 
        hovered: hovered,
      }"
      @mouseover="hoverinJournal"
      @mouseleave="hoveroutJournal"
      @click="clickJournal"
    >
      <span class="bullet" v-if="selected">✕</span>
      <span class="bullet" v-else>⤷</span>
      <span class="value"> {{ title }} </span>
      <span class="date"> {{ moment( date ).format('MMM Do, YYYY') }} </span>
    </a>
    <vue-markdown 
      v-if="selected"
      class="body"
      :source="body"
    />
  </li>
</template>

<script>
import moment from 'moment'

export default {
  name: "journal",
  props: [
    'slug',
    'title',
    'date',
    'body'
  ],
  data() {
    return {
      hovered: false,
      faded: false,
      selected: false,
      fadein: false,
      moment: moment,
    }
  },
  methods: { 
    hoverinJournal () { this.$emit('journalHovered', this) },
    hoveroutJournal () { this.$emit('journalUnhovered', this) },
    clickJournal () { this.$emit('journalClicked', this) },
  },
}
</script>

<style scoped>
.journal a.name span.date {
  width: 7em;
}
.journal.selected.fadein .name {
  position: sticky;
  position: -webkit-sticky;
  top: 0px;
  background: var(--palest-yellow);
}
</style>